/**
 * Enumeration of the various themes supported by Teams app
 */ export var TeamsTheme;
(function(TeamsTheme) {
    /** Default theme which is the light theme experience */ TeamsTheme["Default"] = "default";
    /** Dark theme with darker colors and backgrounds */ TeamsTheme["Dark"] = "dark";
    /** High contrast theme with high contrast colors and backgrounds */ TeamsTheme["Contrast"] = "contrast";
})(TeamsTheme || (TeamsTheme = {}));
